import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { Badge } from "@/components/ui/badge";

const KIND_COLOR = {
  "admin.login": "bg-slate-100 text-slate-700",
  "admin.logout": "bg-slate-100 text-slate-500",
  "kyc.approve": "bg-emerald-100 text-emerald-800",
  "kyc.reject": "bg-rose-100 text-rose-800",
  "kyc.reveal.aadhaar": "bg-amber-100 text-amber-800",
  "kyc.reveal.pan": "bg-amber-100 text-amber-800",
  "kyc.file.view": "bg-amber-50 text-amber-800",
  "kyc.note.update": "bg-slate-100 text-slate-700",
};

const ActivityLog = () => {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    adminApi.get("/activity?limit=200")
      .then((r) => setRows(r.data || []))
      .catch((e) => setErr(e?.response?.data?.detail || "Failed"));
  }, []);
  return (
    <div className="p-8" data-testid="admin-activity">
      <div className="mb-6">
        <h1 className="font-display text-2xl font-extrabold text-slate-900">Admin activity log</h1>
        <p className="text-sm text-slate-500 mt-0.5">Every admin action is recorded here — including sensitive-field reveals.</p>
      </div>
      {err && <div className="text-rose-700 text-sm mb-3">{err}</div>}
      <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
            <tr>
              <th className="text-left px-4 py-2 font-medium">When</th>
              <th className="text-left px-4 py-2 font-medium">Admin</th>
              <th className="text-left px-4 py-2 font-medium">Action</th>
              <th className="text-left px-4 py-2 font-medium">Entity</th>
              <th className="text-left px-4 py-2 font-medium">Note</th>
              <th className="text-left px-4 py-2 font-medium">IP</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100">
                <td className="px-4 py-2 font-mono text-[11px] text-slate-500">{r.created_at?.replace("T"," ").slice(0,19)}</td>
                <td className="px-4 py-2 text-slate-700">{r.admin_email}</td>
                <td className="px-4 py-2"><Badge className={KIND_COLOR[r.action] || "bg-slate-100 text-slate-700"}>{r.action}</Badge></td>
                <td className="px-4 py-2 text-xs text-slate-500">{r.entity} {r.entity_id ? <span className="font-mono">· {r.entity_id.slice(0,8)}</span> : null}</td>
                <td className="px-4 py-2 text-xs text-slate-500 max-w-md truncate">{r.note || "—"}</td>
                <td className="px-4 py-2 font-mono text-[11px] text-slate-400">{r.ip || "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-400">No activity yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActivityLog;
